import React from "react";
import { Row, Col } from "react-bootstrap";
import { ProductCard } from "../";

interface TaxEntry {
  rate: string;
  amount: number;
}

interface ProductItem {
  productId: string;
  name: string;
  unitPrice: string;
  totalPrice: number;
  qty: number;
  available: boolean;
}

interface CheckoutSummaryProps {
  products: ProductItem[];
  total: number;
  taxes: TaxEntry[];
  onQuantityChange: (productId: string, qty: number) => void;
  onDelete: (productId: string) => void;
}

const CheckoutSummary: React.FC<CheckoutSummaryProps> = ({
  products,
  total,
  taxes,
  onQuantityChange,
  onDelete,
}) => {
  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    color: "#342714",
    letterSpacing: ".05em",
  };

  const formStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 600,
    color: "#342714",
    letterSpacing: ".05em",
  };

  const subTitleStyle: React.CSSProperties = {
    fontSize: "2rem",
    fontWeight: 300,
    margin: "calc(2rem - .14286em) 0 0",
    color: "#000000de",
    fontFamily: "Avenir Next Codensed Ultralight",
  };

  return (
    <>
      <Row>
        <Col>
          <div style={subTitleStyle}>Deine Bestellung</div>
        </Col>
      </Row>

      <Row>
        <Col xl={8}><div style={contentStyle}>{products.length} Produkt(e)</div></Col>
        <Col xl={4}><div style={contentStyle}>{total.toFixed(2)} €</div></Col>
      </Row>

      {/* Optional: Lieferung statisch, z. B. später Redux */}
      <Row>
        <Col xl={8}><div style={contentStyle}>Lieferung</div></Col>
        <Col xl={4}><div style={contentStyle}>0,00 €</div></Col>
      </Row>

      <Row className="mt-3">
        <Col xl={8}>
          <div style={formStyle}>Gesamt</div>
          {taxes.map((t, idx) => (
            <div key={idx} style={contentStyle}>
              inkl. MwSt. ({t.rate}): {t.amount.toFixed(2)} €
            </div>
          ))}
        </Col>
        <Col xl={4}>
          <div style={formStyle}>{total.toFixed(2)} €</div>
        </Col>
      </Row>

      <hr />

      <Row>
        {products.map((product) => (
          <ProductCard
            key={product.productId}
            title={product.name}
            price={product.unitPrice}
            totalPrice={product.totalPrice}
            description="Täglich frisch aus unserer Backstube."
            imageUrl="/images/bio-bun.jpg"
            quantityOptions={[1, 2, 3, 4, 5, 6, 7, 8]}
            selectedQuantity={product.qty}
            onQuantityChange={(qty) => onQuantityChange(product.productId, qty)}
            onDelete={() => onDelete(product.productId)}
          />
        ))}
      </Row>
    </>
  );
};

export default CheckoutSummary;
